import React, {FC, useEffect, useRef} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {usePrevious} from '../../../../libs/shared/core/src/helpers/react/hooks/hookHelpers';
import {Input, InputTypesEnum} from '../../../../libs/shared/ui/src/components/inputs/input';
import {markFullStorySensitive} from '../../../helpers/fullstoryHelpers';

/*
 * Props.
 */

interface EmailComposerSubjectProps {
  subject: string;
  onSubjectChange: (arg: string) => void;
  onSubjectBlur: () => void;
  shouldFocus?: boolean;
  focusKey?: unknown;
}

/*
 * Style.
 */

const StyledSubjectDiv = styled.div`
  height: 41px;
  padding: 0px 16px;
  border-bottom: 1px solid ${(p) => p.theme.message.border};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledTitleDiv = styled.div`
  flex: 0 1 0%;
  line-height: normal;
  color: ${(p) => p.theme.greys.shade70};
  margin-right: 6px;
  padding-bottom: 1px;
`;

const StyledInputElement = styled(Input)`
  flex: 1 0 0%;
  line-height: normal;
  color: ${(p) => p.theme.greys.shade90};
  padding-bottom: 1px;
`;

/*
 * Component.
 */

export const EmailComposerSubject: FC<EmailComposerSubjectProps> = (props) => {
  const {subject, onSubjectChange, onSubjectBlur, shouldFocus, focusKey} = props;
  const inputRef = useRef<Input>(null);

  const previousFocusKey = usePrevious(focusKey);
  useEffect(() => {
    // When the focus key is bumped, re-focus if needed.
    if (previousFocusKey !== focusKey && shouldFocus) {
      inputRef.current?.focus();
    }
  });

  return (
    <StyledSubjectDiv>
      <StyledTitleDiv>
        <Trans id="email-composer-subject">Subject:</Trans>
      </StyledTitleDiv>
      <StyledInputElement
        ref={inputRef}
        type={InputTypesEnum.TEXT}
        className={markFullStorySensitive()}
        value={subject}
        onChange={onSubjectChange}
        onBlur={onSubjectBlur}
        shouldFocus={shouldFocus}
        inputId="composer-subject"
      />
    </StyledSubjectDiv>
  );
};
